export default __webpack_public_path__ + "static/media/moki@2x.864526d8.png";